import { render } from "./Hotels.vue?vue&type=template&id=44da4e4e&scoped=true"
import script from "./Hotels.vue?vue&type=script&lang=js"
export * from "./Hotels.vue?vue&type=script&lang=js"

import "./Hotels.vue?vue&type=style&index=0&id=44da4e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44da4e4e"]])

export default __exports__